/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_screen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _modules_storageMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _modules_region__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _modules_share__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var _modules_slider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _modules_readMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _modules_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
/* harmony import */ var _modules_burgerMenu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10);










$(function () {
  Object(_modules_screen__WEBPACK_IMPORTED_MODULE_0__["default"])();
  Object(_modules_storageMenu__WEBPACK_IMPORTED_MODULE_1__["default"])();
  Object(_modules_region__WEBPACK_IMPORTED_MODULE_2__["default"])();
  Object(_modules_share__WEBPACK_IMPORTED_MODULE_3__["default"])();
  Object(_modules_slider__WEBPACK_IMPORTED_MODULE_4__["default"])();
  Object(_modules_readMore__WEBPACK_IMPORTED_MODULE_5__["default"])();
  Object(_modules_tooltip__WEBPACK_IMPORTED_MODULE_6__["default"])();
  Object(_modules_burgerMenu__WEBPACK_IMPORTED_MODULE_7__["default"])();
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);


var screen = function screen() {
  var navSelector = '.nav',
    navItemSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].navItemSelector,
    dataScreen = 'data-screen',
    screenSelector = '.screen',
    screen = $(screenSelector),
    document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
    storageItem = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].storageItem,
    regionInfo = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].regionInfo,
    activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass,
    inActiveClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].inActiveClass,
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    currentClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].currentClass,
    disableClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].disableClass,
    bodyClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].bodyClass;
  function onClickNavItem() {
    document.on('click', navItemSelector, function (e) {
      e.preventDefault();
      var _this = $(this),
        id = _this.attr(dataScreen),
        _screen = $("".concat(screenSelector, "[").concat(dataScreen, "='").concat(id, "']")),
        _data = _this.data('screen'),
        _navItemSelector = $(".header ".concat(navItemSelector, "[").concat(dataScreen, "='").concat(id, "']")),
        _prevScreen = _screen.siblings(screenSelector),
        menuMobileSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].menuMobileSelector,
        btnCloseMenuSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseMenuSelector;
      $(bodyClass).addClass(inActiveClass);
      $(navItemSelector).removeClass(currentClass);
      _navItemSelector.addClass(currentClass);
      screen.removeClass(activeClass);
      _screen.addClass("".concat(showClass, " ").concat(activeClass));
      if (_data === 0) {
        var isPageMain = $('.page-main').length > 0;
        if (isPageMain) {
          $(bodyClass).removeClass(inActiveClass);
          screen.removeClass(showClass);
          closeRegionInfo();
        } else {
          $(bodyClass).removeClass(inActiveClass);
          window.location.href = '/';
        }
      } else {
        setTimeout(function () {
          _prevScreen.removeClass(showClass);
        }, 800);
      }
      if (_data === 3) {
        initHover();
      }
      if ($(menuMobileSelector).hasClass(showClass)) {
        $(btnCloseMenuSelector).click();
      }
      closeRegionInfo();
    });
  }
  ;
  function closeRegionInfo() {
    var btnCloseSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseSelector,
      btnClose = regionInfo.find(btnCloseSelector);
    if (regionInfo.hasClass(showClass)) {
      setTimeout(function () {
        btnClose.click();
      }, 800);
    }
  }
  function initHover() {
    setTimeout(function () {
      storageItem.removeClass(disableClass);
    }, 800);
  }
  ;
  function setAttrNode(nodeSelector, childSelector) {
    var _node = $(nodeSelector);
    _node.each(function (i, item) {
      var _this = $(item),
        children = _this.find(childSelector);
      Object(_modules__WEBPACK_IMPORTED_MODULE_1__["setAttr"])(children, dataScreen);
    });
  }
  ;
  setAttrNode(navSelector, navItemSelector);
  onClickNavItem();
};
/* harmony default export */ __webpack_exports__["default"] = (screen);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classes", function() { return classes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectors", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jQueryObjects", function() { return jQueryObjects; });
var classes = {
  activeClass: 'active',
  inActiveClass: 'inactive',
  showClass: 'show',
  hideClass: 'hide',
  disableClass: 'disable',
  currentClass: 'current',
  errorClass: 'error',
  bodyClass: 'body'
};
var selectors = {
  btnCloseSelector: '.js-btn-close',
  storageItemSelector: '.screen-storage .storage-menu__item',
  regionInfoSelector: '.region-info',
  navItemSelector: '.js-nav-link',
  menuMobileSelector: '.menu-mobile',
  btnCloseMenuSelector: '.menu-mobile .js-btn-close'
};
var jQueryObjects = {
  _window: $(window),
  document: $(document),
  storageItem: $(selectors.storageItemSelector),
  regionInfo: $(selectors.regionInfoSelector)
};


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttr", function() { return setAttr; });
function setAttr(elemSelector, attr) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var elem = $(elemSelector);
  elem.each(function (i, it) {
    $(it).attr(attr, i + count);
  });
}
;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var storageMenu = function storageMenu() {
  var screenStorageSelector = '.screen-storage',
    storageItem = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].storageItem,
    btnCloseSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseSelector,
    navItemSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].navItemSelector,
    btnClose = $("".concat(screenStorageSelector, " ").concat(btnCloseSelector)),
    activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass,
    inActiveClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].inActiveClass,
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    currentClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].currentClass,
    disableClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].disableClass,
    bodyClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].bodyClass;
  function hideMenu() {
    btnClose.on('click', function () {
      var _this = $(this),
        _screen = _this.closest(screenStorageSelector);
      _screen.removeClass("".concat(showClass, " ").concat(activeClass));
      $(bodyClass).removeClass(inActiveClass);
      storageItem.addClass(disableClass);
      $(navItemSelector).removeClass(currentClass);
    });
  }
  ;
  hideMenu();
};
/* harmony default export */ __webpack_exports__["default"] = (storageMenu);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);


var region = function region() {
  var regionItemSelector = '.js-honeycomb-region',
    regionItem = $(regionItemSelector),
    document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
    regionInfo = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].regionInfo,
    btnCloseSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseSelector,
    btnClose = regionInfo.find(btnCloseSelector),
    currentClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].currentClass,
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    screenMap = $('.screen-map'),
    screenMapDesc = $('.screen-map__desc'),
    numbers = screenMap.find('.region-info__numbers'),
    links = screenMap.find('.region-info__link'),
    dataRegion = 'data-region';
  var data = [{
    title: 'Республика Башкортостан',
    numbers: [{
      num: '4430 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '6076 ',
      text: 'Производство меда, тонн'
    }, {
      num: '299,8 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Башкирия – лидер страны по объему продаж меда в 2020 году и второй по величине производитель. Развитию сектора способствует климат и хорошая медоносная база региона, в том числе сельскохозяйственные культуры. Бренд «Башкирский мед» известен не только в России, но и за ее пределами. Летом 2020-го в республике был создан «Межрегиональный центр по защите и продвижению продукции пчеловодства «Алтын Солок», учредителем которого стал Минсельхоз республики. Среди целей объединения - сохранение аборигенной популяции среднерусской пчелы, создание современного селекционного комплекса, предоставление услуг лабораторных исследований, получение меда высокого качества.',
    links: [{
      href: 'https://wildbeehive.ru/',
      title: 'Центр «Алтын Солок»'
    }, {
      href: 'http://roopb.tilda.ws/',
      title: 'Региональная общественная организация «Пчеловоды Башкирии»'
    }, {
      href: 'http://www.bash-med.ru/index.php',
      title: 'Научный центр пчеловодства и апитерапии'
    }]
  }, {
    title: 'Ростовская область',
    numbers: [{
      num: '2554 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '3437 ',
      text: 'Производство меда, тонн'
    }, {
      num: '185,9 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Ростовская область – второй в стране регион по объему продаж меда и один из лидеров по его производству. Благодаря климату и медоносной базе здесь хорошо развито пчеловодство. Породный состав пчел в области довольно разнообразный, например, здесь районирована серая горная кавказская порода пчел. Основная порода области - карпатская, которая быстро развивается весной, хорошо работает как на разнотравье, так и на полях подсолнечника, эспарцета и других агрокультур. Раннее наступление тепла в Ростовской области способствует работе племенных пчелохозяйств, которые могут производить большое количество пчеломаток и пчелопакетов для других регионов.',
    links: [{
      href: 'https://don-agro.ru/index.php/apk/zhivotnovodstvo/pchelovodstvo',
      title: 'Минсельхозпрод Ростовской области (информация по пчеловодству)'
    }]
  }, {
    title: 'Алтайский край',
    numbers: [{
      num: '2427 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '4185 ',
      text: 'Производство меда, тонн'
    }, {
      num: '182,2 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Алтайский край по итогам 2020 года стал третьим в рейтинге по объемам продаж меда. Местный мед по своим характеристикам и показателям качества во многом превосходит сорта из других регионов в том числе благодаря биологическим особенностям местных пчел. Алтайская популяция среднерусской породы представляет огромную ценность для селекционной работы, эти пчелы обладают зимостойкостью, высокой продуктивностью, плодовитостью маток. Для информирования пчеловодов в марте 2020 года в крае в тестовом режиме было запущено приложение «Мобильная пасека» («Регагро: пасека»), также сервис оповещения тестировался в рамках региональной цифровой платформы АИС РЕСПАК.',
    links: [{
      href: 'https://respak.altagro22.ru/',
      title: 'АИС РЕСПАК'
    }]
  }, {
    title: 'Краснодарский край',
    numbers: [{
      num: '2337 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '3484 ',
      text: 'Производство меда, тонн'
    }, {
      num: '145,5 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Краснодарский край по итогам 2020 года стал четвертым в стране по объемам продаж меда и традиционно является одним из крупнейших производителей. Наиболее ценные сорта меда в крае - каштановый, липовый и акациевый, а самый распространенный – подсолнечный. Равнинная территория края – исторический ареал пчел кубанской породы, которую сейчас почти вытеснила карпатская, в горных районах разводят серых горных кавказских пчел. Сейчас Краснодарский край является центром разведения чистопородных карпатских пчел. Поскольку Кубань – один из важнейших сельскохозяйственных регионов страны, развитие пчеловодства крайне важно для агросектора края.',
    links: [{
      href: 'https://msh.krasnodar.ru/deyatelnost/activities/zhivotnovodstvo-i-plemennoe-delo/pchelovodstvo/',
      title: 'Минсельхоз Краснодарского края (информация по пчеловодству)'
    }, {
      href: 'https://apismaykop.ru/index.php?option=com_content&view=article&id=162&Itemid=633+++',
      title: 'ППХ «Майкопское» - филиал ФГБНУ «ФНЦ пчеловодства»'
    }]
  }, {
    title: 'Республика Татарстан',
    numbers: [{
      num: '1762 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '4197 ',
      text: 'Производство меда, тонн'
    }, {
      num: '180,3 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Татарстан замыкает первую пятерку регионов-лидеров по продажам меда в 2020 году. В результате многолетней селекционно-племенной работы с пчелами среднерусской породы в республике был выведен новый породный тип - татарский. Правительство региона уделяет большое внимание развитию отрасли, так, например, среди подведомственных Минсельхозпроду республики организаций есть Управление аквакультуры и пчеловодства, кроме того, пчеловоды региона могут рассчитывать на господдержку. В прошлом году в республике было анонсировано создание информационной системы «Геоуказатель по размещению пасек и количество пчелосемей по муниципальным районам Татарстана».',
    links: [{
      href: 'https://agro.tatarstan.ru/vedorg.htm?department_id=1508',
      title: 'Управление аквакультуры и пчеловодства'
    }, {
      href: 'http://pchelovod.tatar/index.php',
      title: '«Пчеловоды Татарстана»'
    }]
  }, {
    title: 'Белгородская область',
    numbers: [{
      num: '1415 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '2448 ',
      text: 'Производство меда, тонн'
    }, {
      num: '67,3 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Белгородская область по итогам 2020 года стала шестой по объемам продаж меда, также она является его крупнейшим производителем в Центральном федеральном округе. Хотя регион признан «мясной столицей» России, пчеловодству здесь тоже уделяют внимание. Например, в прошлом году в регионе стартовал проект «Возрождение дупляночного (бортевого) пчеловодства». Бортевой мед, который получают от лесных пчел, отличается повышенной экологичностью и уникальным составом. Летом 2020-го Департамент АПК области начал внедрять в регионе информационную систему «ДоброПчел» для координации технологических процессов растениеводов и пчеловодов.',
    links: [{
      href: 'https://belapk.ru/deyatelnost/zhivotnovodstvo/pchelovodstvo/',
      title: 'Департамент АПК Белгородской области (информация по пчеловодству)'
    }, {
      href: 'http://geos.1cps.ru/bee-view/',
      title: 'Белгородская область в системе «ДоброПчел»'
    }]
  }, {
    title: 'Приморский край',
    numbers: [{
      num: '1311 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '6832 ',
      text: 'Производство меда, тонн'
    }, {
      num: '72,5 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Приморье лидирует по производству товарного меда в стране, а по объемам его продаж за прошлый год регион занимает седьмое место. В отличие от других регионов России, в Приморском крае до 99% меда производится из нектара дикорастущих растений, в том числе на долю различных видов липы приходится до 70%. Основной способ медосбора – кочевое пчеловодство. В 2016 году в крае на основе скрещивания украинской и среднерусской пород пчел с незначительным влиянием итальянских и кавказских пчел была выведена новая порода – дальневосточная. В 2018-м на нее был получен патент, в том же году она была допущена к использованию в России.',
    links: [{
      href: 'https://primhoney.ru/',
      title: 'Союз пчеловодов Приморского края'
    }]
  }, {
    title: 'Волгоградская область',
    numbers: [{
      num: '1222 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1324 ',
      text: 'Производство меда, тонн'
    }, {
      num: '30,4 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Волгоградская область в 2020 году заняла восьмое место в стране по объемам продаж меда. Пчеловодство в регионе достаточно хорошо развито и имеет большие перспективы, чему способствуют благоприятный климат и хорошая медоносная база. Здесь выращивается много агрокультур, требующих опыления: подсолнечник, горчица, рапс, бахчевые, гречиха и другие, также есть фруктовые сады и дикорастущие медоносы. Самая популярная порода пчел в регионе - карпатская, она хорошо зимует, миролюбива и удобна при кочевках. На базе Комитета сельского хозяйства области создан Совет пчеловодов, ведется постоянный мониторинг состояния отрасли.',
    links: [{
      href: 'https://ksh.volgograd.ru/coordination/docs/17335/',
      title: 'Комитет сельского хозяйства Волгоградской области (информация по пчеловодству)'
    }]
  }, {
    title: 'Пермский край',
    numbers: [{
      num: '697 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1522 ',
      text: 'Производство меда, тонн'
    }, {
      num: '74,2 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Пермский край в 2020 году стал девятым в стране по объему продаж меда. Регион обладает огромным потенциалом для развития пчеловодства. Коренной породой пчел считается среднерусская, которая идеально подходит для условий региона: она приспособлена к длительному периоду зимовки и короткому, но бурному медосбору. В крае создано несколько племенных пасек, в состав племенного хозяйства «Парасоль» (группа предприятий «Тенториум») входит лаборатория искусственного осеменения пчелиных маток, которая ведет научную работу по сохранению популяции пчел среднерусской породы. Также в регионе хорошо развита переработка продукции пчеловодства.',
    links: [{
      href: 'http://xn----itbabmllczgfn7fuc.xn--p1ai/',
      title: 'Ассоциация пчеловодов Пермского края'
    }, {
      href: 'https://tentorium.ru/parasol/',
      title: 'Племхозяйство «Парасоль»'
    }]
  }, {
    title: 'Тамбовская область',
    numbers: [{
      num: '622 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '942 ',
      text: 'Производство меда, тонн'
    }, {
      num: '35,5 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Тамбовская область замыкает первую десятку регионов по объемам продаж меда в 2020 году. Жители региона с давних пор занимались бортничеством, даже на гербе области изображен улей и три пчелы. Развитию пчеловодства способствует хорошая медоносная база, в том числе представленная энтомофильными агрокультурами. Традиционная для региона порода пчел – среднерусская, которая хорошо адаптирована к местному климату и продуктивна. Хотя здесь представлены и другие породы, в частности карпатская. В прошлом году в регионе был создан региональный реестр пчеловодов, также формируется интерактивная карта размещения пасек в районах области.',
    links: [{
      href: 'http://tambovapk.tmweb.ru/%d0%bf%d1%87%d0%b5%d0%bb%d0%be%d0%b2%d0%be%d0%b4%d1%81%d1%82%d0%b2%d0%be/',
      title: 'Региональный информационно-консультационный центр АПК'
    }, {
      href: 'https://agro.tmbreg.ru/3300.html',
      title: 'Управление сельского хозяйства Тамбовской области (информация по пчеловодству)'
    }, {
      href: 'http://medtambova.ru/aboutus/',
      title: 'Тамбовское общество пчеловодов'
    }]
  }, {
    title: 'Орловская область',
    numbers: [{
      num: '590 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1006 ',
      text: 'Производство меда, тонн'
    }, {
      num: '35,6 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'В 2020 году Орловская область стала 11-й по объему продаж меда. Самая ценная медоносная агрокультура региона – гречиха. Гречишный мед – один из брендов области, известный не только в России, но и за рубежом. Орловской опытной станцией пчеловодства на основе 11 популяций среднерусской породы, завезенных из мест их естественного обитания, был создан тип среднерусских пчел орловский, патент на него получен в 2008 году. Эти пчелы отличаются высокой зимостойкостью и повышенной устойчивостью к заболеваниям. Департаментом АПК региона создан реестр пчеловодов, большое внимание уделяется работе по взаимодействию растениеводов и владельцев пасек.',
    links: [{
      href: 'http://apk.orel-region.ru/index.php?cont=1032',
      title: 'Департамент АПК Орловской области (реестр пчеловодов)'
    }, {
      href: 'http://vista.1cps.ru/bee2-vista/#part=8&page=8',
      title: 'Орловская область на портале «ДоброПчел»'
    }]
  }, {
    title: 'Республика Дагестан',
    numbers: [{
      num: '579 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1155 ',
      text: 'Производство меда, тонн'
    }, {
      num: '119,8 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Дагестан в 2020 году стал 12-м по объемам продаж меда, по его производству регион лидирует в Северо-Кавказском федеральном округе. Природно-климатические условия республики способствуют развитию пчеловодства, это одно из традиционных занятий народов Кавказа. В регионе хорошая медоносная база: альпийские и субальпийские луга, большие массивы смешанных лесов, значительные площади плодовых садов. Традиционная местная порода – серая горная кавказская пчела, но разводят и других, например, бакфаст и карнику. Правительство региона уделяет внимание развитию отрасли, так, в феврале 2017 года в республике был принят закон «О пчеловодстве».',
    links: [{
      href: 'http://mcxrd.ru/news/item/5697',
      title: 'Минсельхозпрод Дагестана (о господдержке пчеловодства в регионе)'
    }]
  }, {
    title: 'Кемеровская область',
    numbers: [{
      num: '578 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1084 ',
      text: 'Производство меда, тонн'
    }, {
      num: '45,9 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Кемеровская область по итогам 2020 года заняла 13-е место по объемам продаж меда. По его производству регион является вторым в Сибирском федеральном округе после Алтайского края. Климат области достаточно благоприятный для разведения пчел. В южной части области растет липа сибирская, поэтому здесь получают почти чистый липовый мед. Среди полевых медоносов большое значение имеют гречиха, рапс, горчица, люцерна и др. В регионе рекомендована для разведения среднерусская порода пчел, которая лучше всего подходит для местного климата - продолжительной зиме и короткому лету. В области предусмотрены меры господдержки для пчеловодов.',
    links: [{
      href: 'http://mcx42.ru/perechen-pchelovodov-i-pchelovodcheskikh-khozyaystv-kuzbassa',
      title: 'Минсельхоз Кузбасса (реестр пчеловодов)'
    }, {
      href: 'https://xn--80aaogruine0k.xn--p1ai/',
      title: 'Союз пчеловодов Кузбасса «Пасека»'
    }]
  }, {
    title: 'Нижегородская область',
    numbers: [{
      num: '570 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '907 ',
      text: 'Производство меда, тонн'
    }, {
      num: '51,9 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Нижегородская область в 2020 году заняла 14-е место по объемам продаж меда. Медоносная база и климат региона в целом благоприятны для развития пчеловодства, хотя дикорастущие растения распределены неравномерно. Однако в области широко представлены агрокультуры-медоносы: гречиха, рапс, подсолнечник, кормовые травы. Районированной породой пчел является среднерусская, однако пчеловоды активно разводят и других: кавказскую, карпатскую, украинскую степную и др., поскольку они более мирные, однако и менее приспособлены к условиям региона, поэтому плохо переносят зиму. В регионе еще в 2008 году был принят закон «О пчеловодстве».',
    links: [{
      href: 'https://www.nn.ru/community/user/pchely/',
      title: 'Онлайн-сообщество для общения пчеловодов'
    }]
  }, {
    title: 'Саратовская область',
    numbers: [{
      num: '559 ',
      text: 'Продажи меда, тонн'
    }, {
      num: '1351 ',
      text: 'Производство меда, тонн'
    }, {
      num: '40,9 ',
      text: 'Количество пчелосемей, тыс.'
    }],
    text: 'Саратовская область замыкает топ-15 регионов по объемам продаж меда в 2020 году. Пчеловодство – неотъемлемая часть АПК региона, поскольку он является крупнейшим в стране производителем подсолнечника. Также в области выращивают другие энтомофильные агрокультуры, есть и дикорастущие медоносы – преимущественно деревья и кустарники. В основном в регионе разводят карпатскую, среднерусскую и кавказскую породы пчел. В области создан реестр пчеловодов, утвержден межведомственный план взаимодействия по развитию пчеловодства и защиты пчел, проводится информационно-разъяснительная работа с растениеводами и владельцами пасек.',
    links: [{
      href: 'https://www.minagro.saratov.gov.ru/pchelovodstvo/index.php?sphrase_id=47955',
      title: 'Минсельхоз Саратовской области (информация по пчеловодству)'
    }, {
      href: 'http://vista.1cps.ru/bee2-vista/#part=11&page=11',
      title: 'Саратовская область на портале «ДоброПчел»'
    }]
  }];
  function onClickRegionItem() {
    document.on('click', regionItemSelector, function (e) {
      e.preventDefault();
      var _this = $(this),
        id = _this.attr(dataRegion),
        isCurrentClass = _this.hasClass(currentClass);
      if (isCurrentClass) {
        return false;
      }
      regionItem.removeClass(currentClass);
      _this.addClass(currentClass);
      regionInfo.addClass(showClass);
      changeRegionInfo(id);
      screenMapDesc.css('opacity', '0');
    });
  }
  ;
  function changeRegionInfo(id) {
    var title = screenMap.find('.region-info__title'),
      text = screenMap.find('.region-info__text');
    numbers.html('');
    links.html('');
    title.hide().fadeIn().text("".concat(data[id].title));
    text.hide().fadeIn().text("".concat(data[id].text));
    renderNumbers(id);
    renderLinks(id);
  }
  ;
  function hideRegionInfo() {
    btnClose.on('click', function () {
      regionInfo.removeClass(showClass);
      regionItem.removeClass(currentClass);
      screenMapDesc.css('opacity', '1');
    });
  }
  ;
  function renderNumbers(id) {
    var template = '';
    for (var i = 0; i < data[id].numbers.length; i++) {
      template += "\n        <div class='region-info__numbers-item text'>\n          <span>".concat(data[id].numbers[i].num, "</span> ").concat(data[id].numbers[i].text, " \n        </div>\n      ");
    }
    numbers.hide().fadeIn().append(template);
  }
  ;
  function renderLinks(id) {
    var template = '';
    for (var i = 0; i < data[id].links.length; i++) {
      template += "\n        <a class='region-info__link-item text text--xs' href=".concat(data[id].links[i].href, " target='_blank'>\n          <mark>").concat(data[id].links[i].title, "</mark>\n        </a>\n      ");
    }
    links.hide().fadeIn().append(template);
  }
  ;
  Object(_modules__WEBPACK_IMPORTED_MODULE_1__["setAttr"])(regionItemSelector, dataRegion);
  onClickRegionItem();
  hideRegionInfo();
};
/* harmony default export */ __webpack_exports__["default"] = (region);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var share = function share() {
  var shareSelector = '.share',
    socialListSelector = '.social-list',
    socialList = $("".concat(shareSelector, " ").concat(socialListSelector)),
    btnShareSelector = '.js-btn-share';
  function initSocialLikes() {
    socialList.socialLikes({
      counters: false
    });
  }
  ;
  function bindShare() {
    var document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
      activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass,
      showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass;
    document.on('click', btnShareSelector, function () {
      var _this = $(this),
        _parent = _this.parent(),
        _socialList = _parent.find(socialListSelector);
      _this.toggleClass(activeClass);
      _socialList.toggleClass(showClass);
    });
    function hideByTime(time) {
      document.on('mouseleave', shareSelector, function () {
        var _this = $(this),
          _btnShare = _this.find(btnShareSelector),
          _socialList = _this.find(socialListSelector),
          isShowClass = _socialList.hasClass(showClass);
        if (isShowClass) {
          this.resetState = setTimeout(function () {
            _btnShare.removeClass(activeClass);
            _socialList.removeClass(showClass);
          }, time);
        }
      });
      document.on('mouseenter', shareSelector, function () {
        var _this = $(this),
          isShowClass = _this.find(socialListSelector).hasClass(showClass);
        if (isShowClass) {
          clearTimeout(this.resetState);
        }
      });
    }
    ;
    hideByTime(4000);
  }
  ;
  bindShare();
  initSocialLikes();
};
/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var slider = function slider() {
  var sliderSelector = '.slider',
    sliderListSelector = '.slider__list',
    sliderList = $(sliderListSelector),
    btnNextSelector = '.btn-arrow--next',
    btnPrevSelector = '.btn-arrow--prev';
  function onClickBtnArrow(btnSelector, method) {
    var btn = $(btnSelector);
    btn.on('click', function () {
      var _slider = $(this).closest(sliderSelector).find(sliderList);
      _slider.slick(method);
    });
  }
  ;
  sliderList.slick({
    adaptiveHeight: true,
    arrows: false,
    dots: false,
    lazyLoad: 'ondemand',
    speed: 700,
    slidesToShow: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        dots: true
      }
    }]
  });
  onClickBtnArrow(btnNextSelector, 'slickNext');
  onClickBtnArrow(btnPrevSelector, 'slickPrev');
};
/* harmony default export */ __webpack_exports__["default"] = (slider);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var readMore = function readMore() {
  function onClickReadMore() {
    var btnReadMoreSelector = '.js-btn-read-more',
      readMoreSelector = '.read-more',
      document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
      activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass;
    document.on('click', btnReadMoreSelector, function (e) {
      e.preventDefault();
      var _this = $(this),
        _readMore = _this.prev(readMoreSelector),
        title = _this.hasClass(activeClass) ? 'Читать далее' : 'Свернуть';
      if (_readMore.length > 0) {
        _this.toggleClass(activeClass).find('mark').text(title);
        _readMore.slideToggle(600);
      }
    });
  }
  ;
  onClickReadMore();
};
/* harmony default export */ __webpack_exports__["default"] = (readMore);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var tooltip = function tooltip() {
  var _window = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"]._window,
    document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
    tooltipSelector = '.tooltip',
    tooltipInfoSelector = '.tooltip__info',
    tooltipInfo = $(tooltipInfoSelector),
    underlaySelector = '.underlay',
    underlay = $(underlaySelector),
    btnCloseSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseSelector,
    tooltipBtnCloseSelector = "".concat(tooltipSelector, " ").concat(btnCloseSelector),
    tooltipBtnClose = $(tooltipBtnCloseSelector),
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    inActiveClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].inActiveClass,
    bodyClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].bodyClass,
    body = $(bodyClass);
  function setTooltipClass() {
    var posCenter = document.outerWidth() / 2,
      _tooltipSelector = '.tooltip:not(.tooltip--center)',
      _tooltip = $(_tooltipSelector),
      tooltipLeftClass = 'tooltip--left',
      tooltipRightClass = 'tooltip--right';
    _tooltip.each(function (i, item) {
      var _this = $(item),
        posX = _this.offset().left;
      if (posX < posCenter) {
        _this.removeClass(tooltipRightClass);
        _this.addClass(tooltipLeftClass);
      } else {
        _this.removeClass(tooltipLeftClass);
        _this.addClass(tooltipRightClass);
      }
    });
  }
  function initTooltip() {
    setTimeout(setTooltipClass(), 500);
    _window.on('resize', setTooltipClass);
  }
  ;
  var isDisableClick;
  function showPopupTooltip() {
    document.on('click', tooltipSelector, function (e) {
      if (isDisableClick) {
        return false;
      }
      var _this = $(this),
        _tooltipInfo = _this.find(tooltipInfoSelector),
        underlay = _this.find(underlaySelector),
        btnClose = _this.find(btnCloseSelector),
        isMark = $(e.target)[0].nodeName === 'MARK';
      if (isMark) {
        underlay.fadeIn();
        btnClose.show();
        tooltipInfo.removeClass(showClass);
        _tooltipInfo.addClass(showClass);
        body.addClass(inActiveClass);
      }
    });
  }
  ;
  function hidePopupTooltip() {
    document.on('click', tooltipBtnCloseSelector, function (e) {
      e.stopPropagation();
      var _this = $(this),
        tooltipInfo = _this.closest(tooltipSelector).find(tooltipInfoSelector);
      underlay.fadeOut();
      _this.hide();
      tooltipInfo.removeClass(showClass);
      body.removeClass(inActiveClass);
    });
  }
  ;
  function resetPopupTooltip() {
    underlay.hide();
    tooltipBtnClose.hide();
    tooltipInfo.removeClass(showClass);
    body.removeClass(inActiveClass);
  }
  ;
  function initPopupTooltip() {
    var isMaxMedia = window.matchMedia('(max-width: 1239px)').matches;
    if (isMaxMedia) {
      isDisableClick = false;
      showPopupTooltip();
      hidePopupTooltip();
    } else {
      isDisableClick = true;
      resetPopupTooltip();
    }
  }
  ;
  initTooltip();
  initPopupTooltip();
  _window.on('resize', initPopupTooltip);
};
/* harmony default export */ __webpack_exports__["default"] = (tooltip);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var burgerMenu = function burgerMenu() {
  var btnMenuSelector = '.js-btn-menu',
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    menuMobileSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].menuMobileSelector,
    btnCloseMenuSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCloseMenuSelector,
    menu = $(menuMobileSelector);
  function showMenu() {
    $(document).on('click', btnMenuSelector, function () {
      menu.addClass(showClass);
    });
  }
  ;
  function hideMenu() {
    $(document).on('click', btnCloseMenuSelector, function () {
      menu.removeClass(showClass);
    });
  }
  ;
  showMenu();
  hideMenu();
};
/* harmony default export */ __webpack_exports__["default"] = (burgerMenu);

/***/ })
/******/ ]);